var Geom = require('./base');

require('./point');

require('./path');

require('./line');

require('./area');

require('./interval');

require('./polygon');

require('./schema');

module.exports = Geom;